'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ExitToApp = {};

exports.__exports = ExitToApp;
